import { observable, computed, makeObservable } from 'mobx';
import { IManager } from 'typings/manager';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';

export class Manager implements IManager {
    employeeSourceId: string;

    @observable firstName: Nullable<string>;

    @observable lastName: Nullable<string>;

    @observable displayName: string;

    @observable jobTitleInternal: string;

    directReportsCount: number;

    allReportsCount: number;

    private readonly _configuration: Nullable<Configuration>;

    constructor(manager: IManager, configuration: Nullable<Configuration>) {
        makeObservable(this);
        this.employeeSourceId = manager.employeeSourceId;
        this.firstName = manager.firstName;
        this.lastName = manager.lastName;
        this.displayName = manager.displayName;
        this.jobTitleInternal = manager.jobTitleInternal;
        this.directReportsCount = manager.directReportsCount;
        this.allReportsCount = manager.allReportsCount;
        this._configuration = configuration;
    }

    @computed
    get initials(): string {
        if (!this.firstName || !this.lastName) {
            return '';
        }

        return `${this.firstName.charAt(0).toUpperCase()}${this.lastName.charAt(0).toUpperCase()}`;
    }

    async exportReportsToCsv(managerSourceIds: string[], directsOnly: boolean = true): Promise<void> {
        const managerDataManager = dataManagerFactory.getManagerDataManager();
        if (!managerDataManager || !this._configuration) {
            return Promise.resolve();
        }

        await managerDataManager.exportReportsToCsv(
            this._configuration.masterAccountId,
            this._configuration.cycleId,
            managerSourceIds,
            directsOnly);
    }
}